export default {
    customer: {
        customerManagement: 'Gestión de Clientes',
        dataStorage: "Almacenamiento de datos",
        databases: "Bases de datos",
        rniManagement: 'Gestión de RNI',
        manageReleases:'Administrar lanzamientos',
        enableFlow:'Habilitar Flujo',
        disableFlow: 'Inhabilitar Flujo',
        rniOnOffFlowHint:'Nota: Activar / desactivar un flujo de rni puede afectar a varios clientes.',
        customerDetails: 'Detalles del Cliente',
        towers: 'Estaciones Base',
        endpoints: 'Puntos Finales',
        routes: 'Rutas',
        towersHistory: 'Historia de las Estación base',
        history: 'historia',
        general: 'General',
        metrics: 'Métrica',
        dataFlow: 'Flujo de Datos',
        security: 'Seguridad',
        securityConfiguration: 'Configuración de Seguridad',
        createCustomer: 'Crear Cliente',
        updateCustomer: 'Actualizar Cliente',
        deleteCustomer: 'Eliminar Cliente',
        updateSecurity: 'Actualizar Seguridad',
        customer: 'Cliente',
        customers: 'Clientes',
        numBaseStations: "Conteo de la estación base",
        numRadios: "Radio Count",
        numRoutes: "Recuento de ruta",
        name: 'Nombre',
        rniName: 'RNI Nombre',
        rniCustomer: 'RNI Cliente ID',
        rniVersion: 'RNI Versión',
        streamerVersion: "Versión Streamer",
        flow: 'Flujo',
        rniVersionNotProvided: 'RNI Versión No Proporcionada',
        rniId: 'RNI ID',
        displayName: 'Nombre para Mostrar',
        rniCustomerHeader: 'RNI Cliente ID',
        description: 'Descripción',
        descriptionOptional: 'Descripción (opcional)',
        staleTimeTowers: 'Estación Base Tiempo Pasado',
        staleTimeEndpoints: 'Punto Final Tiempo Pasado',
        staleTimeTowersMinutes: 'Estación Base Tiempo Pasado (minutos)',
        staleTimeEndpointsMinutes: 'Punto Final Tiempo Pasado (minutos)',
        staleTimeTowersHeader: 'Estación Base Tiempo',
        staleTimeEndpointsHeader: 'Punto Final Tiempo',
        timeUnit: 'Unidad Tiempo',
        tmAdminRotationPolicy: 'tmadmin Política de rotación',
        tmAdminPolicy: {
            TWENTY_FOUR_HOUR: "24 horas",
            SEVEN_DAY: "7 días",
        },
        dataRetention: 'Retención Datos',
        dataRetentionDays: 'Retención Datos (días)',
        dataRetentionHeader: 'Retención Datos (días)',
        lastHeard: 'Último Oído',
        firstHeard: 'Escuchado por Primera Vez',
        modDate: 'Fecha Modificada',
        modUser: 'Usuario Modificado',
        modDateHeader: 'Fecha Modificada',
        modUserHeader: 'Usuario Modificado',
        msgsPerSecond: 'RNI 4 ensajes/Seg',
        heliosMsgsPerSecond: 'RNI 5 Mensajes/Seg',
        webHost: 'Nombre de Host RNI',
        multipleSelected: '(Seleccionado Múltiple)',
        useRniHost: '(Usar Host RNI)',
        securityUser: 'Usuaria',
        securityPassword: 'Contraseña',
        securityStatus: 'Estado',
        securityConfigStatus: 'Seguridad Estado',
        rniExport : "Exportación RNI",
        rniExportData: {
            endpoint: {
                status: "Estado de exportación del terminal RNI",
                lastExportDate: "Fecha de última exportación del terminal RNI",
                nextExportDate: "Próxima fecha de exportación del terminal RNI",
                recordCount: "Recuento de registros de exportación de terminales RNI"
            },
            tower: {
                status: "Estado de exportación de la torre RNI",
                lastExportDate: "Fecha de última exportación de la torre RNI",
                nextExportDate: "Próxima fecha de exportación de la Torre RNI",
                recordCount: "Recuento récord de exportaciones de torres RNI"
            },
            risrds: {
                status: "Estado de exportación de RNI RIS",
                lastExportDate: "RNI RIS Última fecha de exportación",
                nextExportDate: "RNI RIS Próxima Fecha de Exportación",
                recordCount: "Recuento de registros de exportación de RNI RIS"
            }
        },
        publicKey: 'Llave Pública',
        securityMessage: 'Mensaje',
        customerCreated: 'El cliente \'{name}\' fue creado exitosamente',
        customerUpdated: 'El cliente \'{name}\' fue actualizado exitosamente',
        securityUpdateRequested: {
            none: 'No se solicitó ninguna actualización de seguridad',
            single: "Se ha solicitado una actualización de seguridad para el cliente '{name}'. Puede tardar unos minutos en completarse.",
            many: "Se han solicitado actualizaciones de seguridad para los clientes '{num}'. Es posible que tarden unos minutos en completarse."
        },
        valueIsRequired: 'Se requiere valor',
        customerMustBeLowerCase: 'El cliente debe estar en minúsculas',
        deleteCustomerPrompt: '¿Estás seguro de que quieres borrar el cliente \'{name}\'?',
        disableRNIFlow: '¿Está seguro de que desea deshabilitar las RNI seleccionada(s)?',
        customerDeleted: 'El cliente {name} fue eliminado exitosamente',
        rniFlowDisabled: 'No se deshabilitó el flujo RNI | 1 flujo RNI fue deshabilitado con éxito | {num} flujo RNI fue deshabilitado con éxito',
        rniFlowEnabled: 'No se habilitó el flujo RNI | 1 flujo RNI fue habilitado con éxito | {num} flujo RNI fue habilitado con éxito',
        clickPasswordIconTooltipShow: 'Haga clic para mostrar la contraseña',
        clickPasswordIconTooltipHide: 'Haga clic para ocultar la contraseña',
        getCustomersError: 'Error al recuperar clientes',
        getCustomerRatesError: 'Error al recuperar las tasas de datos del cliente',
        getCustomerForUpdateError: 'Error al recuperar el cliente \'{name}\' para la actualización',
        deleteCustomerError: 'Error al eliminar cliente \'{name}\'',
        disableFlowError: 'Error al deshabilitar el flujo de RNI \'{name}\'',
        enableFlowError: 'Error al habilitar el flujo de RNI \'{name}\'',
        retrieveDetailsError: 'Error al recuperar cliente \'{name}\'',
        createCustomerError: 'Error al crear cliente',
        updateCustomerError: 'Error al actualizar al cliente',
        duplicateCustomerNameError: 'Nombre de cliente duplicado: \'{name}\'',
        rniIdAlreadyMappedError: 'El ID de RNI y el Cliente de RNI ya se han asignado',
        getSecurityError: 'Error al recuperar los datos de seguridad para cliente \'{name}\'',
        getSecurityForUpdateError: 'Error al recuperar los datos de seguridad para la actualización',
        updateSecurityError: 'Error al actualizar la seguridad para el cliente \'{name}\'',
        getAllSecurityError: 'Error al recuperar el estado de seguridad para la lista de clientes',
        staleTimeTowerTooShort: 'La estación base debe ser de al menos 5 minutos',
        staleTimeEndpointTooShort: 'Endpoint Stale Time debe ser al menos 1 hora',
        securityStatuses: {
            IN_PROGRESS: 'En Progreso',
            SUBMITTED: 'Presentado',
            COMPLETED: 'Terminada',
            FAILED: 'Ha Fallado'
        },
        securityCodes: {
            GENERIC_FAILURE: 'Un error desconocido ocurrió',
            ERROR_CREATING_CLIENT_REGISTRATION: 'Error al crear el registro del cliente',
            ERROR_GETTING_SECURITY_CONFIGURATION: 'No se puede obtener la configuración de seguridad',
            ERROR_CREATING_REALM: 'Error al crear el reino',
            ERROR_CREATING_CLIENT: 'Error al crear el cliente',
            ERROR_ACCESS_TOKEN: 'Error al obtener un token de acceso',
            COPYING_SCRIPT_TO_RNI: 'Copiando script a RNI',
            FAILED_TO_COPY_SCRIPT_TO_RNI: 'Error al copiar el script a RNI',
            SCRIPT_COPIED_TO_RNI: 'Script copiado correctamente a RNI',
            SCRIPT_CONVERTED_TO_UNIX: 'Script convertido a formato Unix',
            SCRIPT_RUNNING: 'El script se está ejecutando en RNI',
            SCRIPT_FAILED_TO_EXECUTE: 'El script no se ejecutó correctamente en RNI',
            SCRIPT_SUCCESSFULLY_EXECUTED: 'Script ejecutado exitosamente en RNI',
            SCRIPT_RESULTS_COPIED_BACK: 'Los resultados de la secuencia de comandos se copiaron correctamente desde RNI',
            SCRIPT_CLEANED_UP_RNI: 'Archivos limpiados exitosamente en RNI',
            PROCESS_COMPLETED_SUCCESSFULLY: 'Procesamiento de seguridad completado con éxito',
            ERROR_COPYING_FILE_TO_RNI: 'Error al copiar el archivo a RNI'
        },
        switchDesc: 'Haga clic para cambiar de cliente',
        dialogTitle: 'Cambiar de Cliente',
        picker: 'Cliente Activo',
        other: 'Otro',
        updateThresholds: 'Actualizar umbrales',
        buddyThresholdsSubtitle: 'Umbrales de amigos',
        tuningThresholdsSubtitle: 'Umbrales de ajuste',
        minValueRequired: 'El valor mínimo requerido es {value}',
        maxValueRequired: 'El valor máximo admitido es {value}',
        valueRequired: 'Se requiere valor',
        tuneThresholds: {
            analysisDays: {
                label: 'Días de Análisis',
                hint: "Número de días para revisar la serie temporal de tiempo de baseStationLag en busca de datos."
            },
            readAnalysisDays: {
                label: 'Días de Análisis de Lecturas',
                hint: "Número de días de datos de lecturas a usar para determinar lagunas de lecturas y cálculos de rendimiento.",
            },
            directRouteDays: {
                label: 'Días de Ruta Directa',
                hint: "Número de días hacia atrás para buscar una ruta directa: directRouteCutOffDate.",
            },
            freqHysteresisDays: {
                label: 'Días de Histéresis de Frecuencia',
                hint: "Número de días para verificar el cambio de frecuencia.",
            },
            minDownLinkDirectRoutess: {
                label: 'Mínimo de Fuerza de Señal de Ruta Directa de Enlace Descendente',
                hint: "Fuerza de señal promedio mínima de la ruta de enlace descendente. Utilizado para determinar si es sospechoso (isSuspectedORD).",
            },
            tempOrdUplinkRouteDays: {
                label: 'Días de Enlace Ascendente Temp ORD',
                hint: 'Número de días de ruta de enlace ascendente utilizados para determinar la elegibilidad de Temp ORD'
            },
            tempOrdMinDownlinkDirectRouteSNR: {
                label: 'SNR de Ruta Directa de Descenso Mínimo de Temp ORD',
                hint: "SNR mínimo de la ruta de descenso al determinar Temp ORD"
            },
            tuningUplinkBestTowerSNRThreshold: {
                label: 'Umbral de relación señal-ruido (SNR) óptimo de la estación base (dB)',
                hint: "Umbral de SNR para que una estación base sea considerada en el mejor cálculo de estación base para la elegibilidad de sintonización",
            }
        },
        buddyThresholds: {
            minAllowableDistanceBetweenStaticRebroadcasters: {
                label: 'Distancia Mínima Permitida Entre Repetidores Estáticos',
                hint: "Distancia mínima permitida entre repetidores estáticos",
            },
            minBuddyToTowerSNR: {
                label: 'Relación Señal-Ruido Mínima de Buddy a Torre',
                hint: "SNR (Relación Señal-Ruido) mínima para buddies hacia la torre.",
            },
            minORDToBuddySignalStrength: {
                label: 'Fuerza de Señal Mínima de ORD a Buddy',
                hint: "Fuerza de señal mínima de ORD a buddy."
            },
            staticRebroadcasterCoverageOverlapQuota: {
                label: 'Cuota de Superposición de Cobertura de Repetidor Estático',
                hint: "Cuota de superposición de cobertura para repetidores estáticos."   
            },
            staticRebroadcasterMinORDCoverageQuota: {
                label: 'Cuota de Cobertura Mínima de ORD para Repetidor Estático',
                hint: "Cuota de cobertura mínima de ORD para repetidores estáticos.",
            }
        },
        staleFilters: {
            fifteenMinutesPlus: "15+ minutos",
            thirtyMinutesPlus: "30+ minutos",
            onePlusHr: "1+ Hora",
            fourPlusHr: "4+ Hora"
        },
        features: "Características",
        featuresList: {
            NETMET: "Network Metrics",
            NETTUNE: "Network Tuning",
            NETCONFIGURE: "Network Configuration"
        },
        rniExportStatus: {
            IN_PROGRESS: "En curso",
            COMPLETE: "Completo"
        },
        etfControl: "Habilitar función de sintonización",
        ecfControl: "Habilitar la función de configuración",
        enableLatLongOTAFlag: "Habilitar actualización de lat/long de radio a través de mensajes OTA",
        rapidTuneConfiguration: {
            enabled: 'Habilitar ajuste rápido',
            rapidTunePeriod: {
                label: 'Intervalo de Barrido en Segundos',
                hint: 'Frecuencia de los "barridos" de Ajuste Rápido para verificar y comandar CommsHubs.',
                suffix: '',
            },
            minUplinkSamples: {
                label: 'Muestras Mínimas de Enlace Ascendente',
                hint: 'Mensajes de enlace ascendente requeridos de una torre para ser elegible para Ajuste Rápido.',
                suffix: '',
            },
            minDownlinkSamples: {
                label: 'Muestras Mínimas de Enlace Descendente',
                hint: 'Muestras de enlace descendente requeridas (sincronizaciones de tiempo o Informes de Torre) para ser elegible para Ajuste Rápido.',
                suffix: '',
            },
            minUplinkSnr: {
                label: 'SNR Mínimo de Enlace Ascendente',
                hint: 'SNR promedio mínimo de enlace ascendente para ser elegible para Ajuste Rápido en un TGB.',
                suffix: '',
            },
            minDownlinkSnr: {
                label: 'SNR Mínimo de Enlace Descendente',
                hint: 'SNR promedio mínimo de enlace descendente para ser elegible para Ajuste Rápido en un TGB.',
                suffix: '',
            },
            maxUplinkStdDev: {
                label: 'Desviación Estándar Máxima de Enlace Ascendente',
                hint: 'Desviación de SNR de enlace ascendente permitida para ser elegible para Ajuste Rápido.',
                suffix: '',
            },
            expirationIntervalMinutes: {
                label: 'Intervalo de Expiración en Minutos',
                labelShort: 'Intervalo de Expiración',
                hint: 'Tiempo antes de que un CommsHub no ajustado expire del Ajuste Rápido.',
                suffix: '',
            },
            minimumMinutesForTuning: {
                label: 'Minutos Mínimos para Ajuste',
                hint: 'Tiempo que un CommsHub es escuchado por NCS antes de ser elegible para RapidTune.',
                suffix: '',
            },
            historyRetentionDays: {
                label: 'Días de Retención de Historial',
                hint: 'Número de días para conservar el historial de ajuste rápido.',
                suffix: '',
            },
        },
        updateEtlTowerChannelsTaskConfiguration: 'Actualizar configuración de Tarea de canales de torre ETL',
        deleteOfStalesTowerChannels: 'Eliminar canales obsoletos de torre',
        exportPrimaryChannelsOnly: 'Exportar solo canales primarios',
        updateDlogInfoMsg: "Los cambios del cliente requieren que el usuario cierre sesión/inicie sesión (o actualice el navegador) para ser visto",
        towerCmdMax: "Comandos máximos enviados por estación base por hora",
        twrCmdsMinError: "Los comandos mínimos por estación base por hora deben ser > 0",
        twrCmdsMaxError: "El máximo de comandos por estación base por hora debe ser <= 999",
        streamerToken: {
            title: 'Token de Incorporación de Streamers',
            description: 'Usa este token para permitir que un nuevo transmisor se conecte a NCS. Introduce la cadena de token en el archivo de arranque de cada NC que quieras añadir a NCS. Este token es válido hasta el {expirationTime}.',
            bootstrapPathLabel: 'Ruta del Archivo Bootstrap',
            tokenLabel: 'Token',
            errorFetchingToken: 'Error al recuperar el token',
            action: 'Obtener Token de Streamer',
            copyPathTooltip: 'Copiar Ruta',
            copyTokenTooltip: 'Copiar Token',
        }
    }
}
